import ZigZagCards from "../components/zig-zag-cards/ZigZagCards";
import '../components/cards/CardSection';
import './petroleum.css';
import CardSection from "../components/cards/CardSection";
import Map from "../components/map/Map";

const Hotels = () => {

  const zigzagCardsData = [
    {
      title: 'Ayesha Hospitality',
      description: <span>
        <div>La Quinta Inn & Suites</div> <div>3709 E. Mulberry St, Fort Collins, CO 80524</div>
      </span>,
      image: '/la-quita.jpg',
      url: 'https://www.wyndhamhotels.com/laquinta/fort-collins-colorado/la-quinta-inn-fort-collins/overview?CID=LC:6ysy27krtpcrqev:52675&iata=00093796'
    },
    {
      title: 'Firestone Hospitality',
      description: <span>
        <div>Comfort Suites</div>
        <div>11292 Business Park Cir, Firestone, CO 80504</div>
      </span>,
      image: '/comfort-suites.jpg',
      utl: 'https://www.choicehotels.com/colorado/firestone/comfort-suites-hotels/co236?mc=llgoxxpx'
    },
    {
      title: 'FTC Hospitality',
      description: <span>
        <div>Quality Inn  & Suites</div>
        <div>4001 S. Mason St, Fort Collins, CO 80525</div>
      </span>,
      image: '/quality-inn.jpg',
      url: 'https://www.choicehotels.com/colorado/fort-collins/quality-inn-hotels/co153'
    },
    {
      title: 'Loveland Hospitality ',
      description: <span>
        <div>Wingate/Hawthorn Suites</div>
        <div>5360 Ronald Reagan Blvd, Johnstown, CO 80534</div>
      </span>,
      image: '/Wingate.jpg',
      url: 'https://www.wyndhamhotels.com/wingate/johnstown-colorado/wingate-by-wyndham-loveland/overview?CID=LC:7hcm1fujuihd89e:47347&iata=00093796'
    },
    {
      title: 'Spark Hospitality ',
      description: <span>
        <div>Comfort Suites</div> 
        <div>1415 Oakridge Dr, Fort Collins, CO 80525</div>
      </span>,
      image: '/comfort-suites-oakridge.jpg',
      url: 'https://www.choicehotels.com/colorado/fort-collins/comfort-suites-hotels/co706?mc=llgoxxpx'
    },
    {
      title: 'Spirit Hospitality ',
      description: <span>
        <div>Comfort Suites</div> 
        <div>7260 W, Jefferson AVE, Lakewood, CO 80235</div>
      </span>,
      image: '/comfort-suites-jefferson.jpg',
      url: 'https://www.choicehotels.com/colorado/lakewood/comfort-suites-hotels/co104'
    },
    {
      title: 'MDR Hospitality',
      description: <span>
        <div>Best Western</div> 
        <div>2005 Main St, Alamosa, CO 81101</div>
      </span>,
      image: '/best-western-alamosa.jpg',
      url: 'https://www.bestwestern.com/en_US/book/hotel-rooms.06001.html?iata=00171880&ssob=BLBWI0004G&cid=BLBWI0004G:google:gmb:06001'
    },
    {
      title: 'NBA Hospitality ',
      description: <span>
        <div>Best Western</div> 
        <div>1638 East Mullberry Street, Fort Collins, CO 80524</div>
      </span>,
      image: '/best-western-muelberry.jpg',
      url: 'https://www.bestwestern.com/en_US/book/hotel-rooms.06156.html?iata=00171880&ssob=BLBWI0004G&cid=BLBWI0004G:google:gmb:06156'
    },
    {
      title: 'Xion Hospitality',
      description: <span>
        <div>Holiday Inn Express</div> 
        <div>2450 N. Town Center Dr, Washington, UT 84780</div>
      </span>,
      image: '/Holiday-Inn-Express.jpg',
      url: 'https://www.ihg.com/holidayinnexpress/hotels/us/en/washington/wssut/hoteldetail?cm_mmc=GoogleMaps-_-EX-_-US-_-WSSUT'
    },
    {
      title: 'Anika Hospitality ',
      description: <span>
        <div>Super 8</div> 
        <div>3725 N. Kasper Ave, Flagstaff, AZ 86004</div>
      </span>,
      image: '/super8.jpg',
      url: 'https://www.wyndhamhotels.com/super-8/flagstaff-arizona/super-8-flagstaff/overview?CID=LC:yytq4fvvehxh7se:02918&iata=00093796'
    },
    {
      title: 'Nas Hospitality',
      description: <span>
        <div>Quality Inn  & Suites</div> 
        <div>1029 N Grand Canyon Blvd., Williams, AZ 86046</div>
      </span>,
      image: '/quality-inn-grand-canyon.jpg',
      url: 'https://www.choicehotels.com/arizona/williams/quality-inn-hotels/az365?mc=llgoxxpx'
    },
    {
      title: 'Colorado Hospitality ',
      description: <span>
        <div>Motel 6</div> 
        <div>776 Horizon Dr, Grand Junction, CO, 81506</div>
      </span>,
      image: '/mortal6.jpg',
      url: 'https://www.motel6.com/en/home/motels.co.grand-junction.8963.html?lid=Local_Milestone_8963&travelAgentNumber=TA001305&corporatePlusNumber=CP792N5W&utm_source=google%20my%20business&utm_medium=listing&utm_campaign=visit%20website'
    },
    {
      title: 'Azur hotel',
      description: <span>
        <div>Azure Hotel & Suites</div>  
        <div>1945 E Holt Blvd, Ontario, CA, 91761-2116</div>
      </span>,
      image: "/petroleum/Azure-hotel.png",
      url: 'https://www.wyndhamhotels.com/trademark/ontario-california/azure-hotel-suites-ontario-ca/overview'
    },
    {
      title: 'Fairfield by Marriott, Lake wood, CO',
      description: <span>
        <div>Fairfield Inn & Suites Denver Southwest / Lakewood</div>  
        <div>3605 South Wadsworth Blvd, Lakewood, CO 80235 US</div>
      </span>,
      image: "/petroleum/fairfield-CO.png",
      url: 'https://hotelguides.com/travel/hotel/307584.html?googleCampaignId=21338284510&googleAdGroupId=164608484324&googleAdId=707887419824&keyword=&matchType=a&googleKeywordId=&adExtensionId=&network=g&adPosition=&deviceType=m&physicalLocation=9190696&interestLocation=&targetId=kwl-3500001&placement=&gad_source=1&gad_campaignid=21338284510&gbraid=0AAAAA9mw6kClVyoVhql9g1y4xwJmDAb2z'
    },
    {
      title: 'Fairfield by Marriott, Kanab , UT',
      description: <span>
        <div>Fairfield by Marriott Inn & Suites Kanab</div>  
        <div>466 S 850 E , Kanab, Utah, USA, 84741</div>
      </span>,
      image: "/petroleum/fairfield-UT.png",
      url: 'https://www.marriott.com/en-us/hotels/pgakf-fairfield-inn-and-suites-kanab/overview/'
    },
    
    
  ];

  const mapData = [
    {
     name: "Ayesha Hospitality",
     imageurl: '/petroleum/Yucaipa-Gas-Mart.png',
     address: "3709 E. Mulberry St, Fort Collins, CO 80524"
    },
    {
     name: "Firestone Hospitality",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "11292 Business Park Cir, Firestone, CO 80504"
    },
    {
     name: "FTC Hospitality ",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "4001 S. Mason St, Fort Collins, CO 80525"
    },
    {
     name: "Loveland Hospitality ",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "5360 Ronald Reagan Blvd, Johnstown, CO 80534"
    },
    {
     name: "Spark Hospitality ",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "1415 Oakridge Dr, Fort Collins, CO 80525"
    },
    {
      name: "Spirit Hospitality ",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "7260 W, Jefferson AVE, Lakewood, CO 80235"
    },
    {
      name: "MDR Hospitality ",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "2005 Main St, Alamosa, CO 81101"
    },
    {
      name: "NBA Hospitality",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "1638 East Mullberry Street, Fort Collins, CO 80524"
    },
    {
      name: "Xion Hospitality",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "2450 N. Town Center Dr, Washington, UT 84780"
    },
    {
      name: "Anika Hospitality ",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "3725 N. Kasper Ave, Flagstaff, AZ 86004"
    },
    {
      name: "Nas Hospitality",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "1029 N Grand Canyon Blvd., Williams, AZ 86046"
    },
    {
      name: "Colorado Hospitality ",
      imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
      address: "776 Horizon Dr, Grand Junction, CO, 81506"
    },
    {
      name: "Azur hotel",
      imageUrl: "/petroleum/Azure-hotel.png",
      address: "1945 E Holt Blvd, Ontario, CA, 91761-2116",
    },
    {
      name: "Fairfield by Marriott, Lake wood, CO",
      imageUrl: "/petroleum/fairfield-CO.png",
      address: "3605 South Wadsworth Blvd, Lakewood, CO 80235 US"
    },
    {
      name: "Fairfield by Marriott, Kanab , UT",
      imageUrl: "/petroleum/fairfield-UT.png",
      address: "466 S 850 E , Kanab, Utah, USA, 84741"
    }  
  ];

  
  return (
    <div className="hotels-container">
      <div className="banner-section">
        <img src="/hotels.png" />
        <h1>
          HOTELS
        </h1>
      </div>
      <div className="content-section">
        <ZigZagCards cards={zigzagCardsData}  />
        {/* <Map data={mapData} /> */}
      </div>
    </div>
  );

};

export default Hotels;